<template>
  <div id="app">
    <flash-message></flash-message>
    <AuthPopups />
    <WriteMessagePopup />
    <Menu />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import AuthPopups from "@/components/AuthPopups.vue";
import WriteMessagePopup from "@/components/WriteMessagePopup.vue";
import Menu from "@/components/Menu.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    AuthPopups, WriteMessagePopup, Menu, Footer
  }
};
</script>

<style>
body {
  margin: 0px;
  background-color: #f2eff8;
}
</style>
